import { render, staticRenderFns } from "./remote_device.vue?vue&type=template&id=c8bdd134&scoped=true&"
import script from "./remote_device.vue?vue&type=script&lang=js&"
export * from "./remote_device.vue?vue&type=script&lang=js&"
import style0 from "./remote_device.vue?vue&type=style&index=0&id=c8bdd134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bdd134",
  null
  
)

export default component.exports